// src/redux/maintenanceSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_maintenance,
  add_maintenance,
  update_maintenance,
  delete_maintenance,
  get_maintenance_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  maintenance: [],
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    is_scheduled:false,
    start_time:"",
    end_time:"",
    message:"",
  },
};

// Async Thunks for API Calls
export const fetchmaintenance = createAsyncThunk(
  "maintenance/fetchmaintenance",
  async ({ page, page_size,search, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_maintenance(page, page_size,search,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createmaintenance = createAsyncThunk(
  "maintenance/createmaintenance",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_maintenance(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatemaintenance = createAsyncThunk(
  "maintenance/updatemaintenance",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_maintenance(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletemaintenance = createAsyncThunk(
  "maintenance/deletemaintenance",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_maintenance({ ids },token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// maintenance Slice
const maintenanceSlice = createSlice({
  name: 'maintenances',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(reduxState, action) {
      reduxState.formData = { ...action.payload };
    },
    resetFormData(state) {
      state.formData = {
        is_scheduled:false,
    start_time:"",
    end_time:"",
    message:"",
      };
    },
    setmaintenance(state, action) {
      state.maintenance = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
 
  },
  extraReducers: (builder) => {
    builder

       // Fetch maintenance
       .addCase(fetchmaintenance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchmaintenance.fulfilled, (state, action) => {
        state.loading = false;
        state.maintenance = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchmaintenance.rejected, (state, action) => {
        state.loading = false;
        state.maintenance = [];
        state.error = action.payload;
      })

      // Add maintenance
      .addCase(createmaintenance.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createmaintenance.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createmaintenance.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update maintenance
      .addCase(updatemaintenance.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatemaintenance.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatemaintenance.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete maintenance
      .addCase(deletemaintenance.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletemaintenance.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletemaintenance.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setmaintenance,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setPageSize } = maintenanceSlice.actions;
export default maintenanceSlice.reducer;
